module.exports = __webpack_public_path__ + "static/media/search-location-solid.7324379b.svg";